import { isPlannerGroup } from "../../state/selectors.js";

export function isPlannerReviewDayPhase(now = "", cutoffHour = 2) {
  const date = new Date(now || Date.now());
  if (Number.isNaN(date.getTime())) return false;
  return date.getHours() < cutoffHour;
}

export function plannerGroupChildren(items = [], groupId = "", comparePlannerVisualOrder = () => 0) {
  const clean = String(groupId || "").trim();
  if (!clean) return [];
  return [...(items || [])]
    .filter((item) => String(item.plannerGroupId || "").trim() === clean)
    .sort(comparePlannerVisualOrder);
}

export function plannerTopLevelItems(items = []) {
  return [...(items || [])].filter((item) => !String(item.plannerGroupId || "").trim());
}

export function plannerGroupSubjectList(item = {}, children = []) {
  if (Array.isArray(item.subjects) && item.subjects.length) return [...item.subjects];
  if (item.subject) return [item.subject];
  return [...new Set(children.map((entry) => entry.subject || "Geral").filter(Boolean))];
}

export function plannerSubjectsLabel(item = {}, children = [], flashcardLabel = "") {
  if (isPlannerGroup(item)) {
    const subjectsList = plannerGroupSubjectList(item, children);
    if (!subjectsList.length) return "Grupo";
    return subjectsList.length === 1 ? subjectsList[0] : `${subjectsList.length} materias`;
  }
  if (flashcardLabel) return flashcardLabel;
  if (Array.isArray(item.subjects) && item.subjects.length) return item.subjects.join(", ");
  return item.subject || "Geral";
}

export function plannerGroupDone(children = []) {
  return children.length > 0 && children.every((item) => Boolean(item.done));
}

export function plannerGroupStatus(children = [], taskStatus = (item = {}) => (item.done ? "done" : item.status || "todo")) {
  if (!children.length) return "todo";
  if (plannerGroupDone(children)) return "done";
  if (children.some((item) => taskStatus(item) === "doing")) return "doing";
  if (children.every((item) => taskStatus(item) === "later")) return "later";
  if (children.some((item) => taskStatus(item) === "todo")) return "todo";
  if (children.some((item) => taskStatus(item) === "later")) return "later";
  return "todo";
}

export function plannerGroupDate(children = [], fallback = "") {
  const datedChildren = [...children]
    .filter((item) => String(item.date || "").trim())
    .sort((a, b) => `${a.date || ""} ${a.time || ""}`.localeCompare(`${b.date || ""} ${b.time || ""}`));
  return datedChildren[0]?.date || fallback || "";
}

export function plannerGroupSchedule(children = [], fallbackDate = "") {
  const date = plannerGroupDate(children, fallbackDate);
  const timedChildren = children.filter((item) => String(item.time || "").trim());
  const orderedTimes = [...timedChildren].sort((a, b) => String(a.time || "").localeCompare(String(b.time || "")));
  return {
    date,
    time: orderedTimes[0]?.time || "",
    endTime: orderedTimes.at(-1)?.endTime || "",
  };
}

export function plannerOverdue(item = {}, todayValue = "") {
  const date = String(item.date || "").trim();
  return Boolean(!item.done && date && todayValue && date < todayValue);
}
